export default __webpack_public_path__ + "static/media/bird.7ac3d9fe.png";